import moment from 'moment';
import Raven from 'raven-js';

export function isNumeric(num){
  if (!num) return false;
  if (typeof num === 'number') return true;
  if (typeof num !== 'string') return false;

  if (num === "") return false;
  if (hasWhiteSpace(num)) return false;
  return !isNaN(num)
}

function hasWhiteSpace(s) {
  return s.indexOf(' ') >= 0;
}

export function verseHash(verse) {
  if (!verse) return 1;
  return verse.book * 70 + verse.startChapter
}

function isObject ( obj ) {
  return obj && (typeof obj  === "object");
}

function isArray ( obj ) {
  return isObject(obj) && (obj instanceof Array);
}

export function setSubState(context, comp, id, val) {
  let object = context.state[comp] || {};
  object[id] = val;
  let obj = {};
  obj[comp] = object;
  context.setState(obj);
}

export function toCSV(object, format) {
  var returnStr = '';

  var formatFunc = format || function(item) { return item }

  if (isArray(object))
    object.forEach(function(item, i, arr) {
      //console.log(item);
      returnStr += formatFunc(item) + (i + 1 === arr.length ? "" : ", ");
    });
  else
    Object.keys(object).forEach(function(key, i, arr) {
      //console.log(item);
      returnStr += formatFunc(object[key]) + (i + 1 === arr.length ? "" : ", ");
    });

  return returnStr;
}

export function formatDate(startDate, endDate) {
  let start = moment.unix(startDate);
  let end = moment.unix(endDate);
  return (start.date() !== end.date()) ? (start.format("MMMM Do @ h:mm A") + " to " + end.format("MMMM Do @ h:mm A")) : start.format("MMMM Do @ h:mm A");
}

export function clone(obj, exclude = []) {
  var copy;

  // Handle the 3 simple types, and null or undefined
  if (null == obj || "object" != typeof obj) return obj;

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr) && exclude.indexOf(attr) === -1)  {
        copy[attr] = clone(obj[attr]);
      }
    }
    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}

export function formatVerse(verse) {
  if (!verse) return "";
  let covered = getBookName(verse.book) + " " + verse.startChapter;
  if (verse.startVerse) covered += ":" + verse.startVerse;
  if (verse.endChapter) covered += " - " + verse.endChapter;
  if (verse.endVerse) covered += (verse.endChapter ? ":" : "-") + verse.endVerse;
  return covered;
}

export function getBookName(book) {
  switch (book.toString()) {
    case "0": return "Genesis";
    case "1": return "Exodus";
    case "2": return "Leviticus";
    case "3": return "Numbers";
    case "4": return "Deuteronomy";
    case "5": return "Joshua";
    case "6": return "Judges";
    case "7": return "Ruth";
    case "8": return "1 Samuel";
    case "9": return "2 Samuel";
    case "10": return "1 Kings";
    case "11": return "2 Kings";
    case "12": return "1 Chronicles";
    case "13": return "2 Chronicles";
    case "14": return "Ezra";
    case "15": return "Nehemiah";
    case "16": return "Esther";
    case "17": return "Job";
    case "18": return "Psalms";
    case "19": return "Proverbs";
    case "20": return "Ecclesiastes";
    case "21": return "Song of Solomon";
    case "22": return "Isaiah";
    case "23": return "Jeremiah";
    case "24": return "Lamentations";
    case "25": return "Ezekiel";
    case "26": return "Daniel";
    case "27": return "Hosea";
    case "28": return "Joel";
    case "29": return "Amos";
    case "30": return "Obadiah";
    case "31": return "Jonah";
    case "32": return "Micah";
    case "33": return "Nahum";
    case "34": return "Habakkuk";
    case "35": return "Zephaniah";
    case "36": return "Haggai";
    case "37": return "Zechariah";
    case "38": return "Malachi";
    case "39": return "Matthew";
    case "40": return "Mark";
    case "41": return "Luke";
    case "42": return "John";
    case "43": return "Acts";
    case "44": return "Romans";
    case "45": return "1 Corinthians";
    case "46": return "2 Corinthians";
    case "47": return "Galatians";
    case "48": return "Ephesians";
    case "49": return "Philippians";
    case "50": return "Colossians";
    case "51": return "1 Thessalonians";
    case "52": return "2 Thessalonians";
    case "53": return "1 Timothy";
    case "54": return "2 Timothy";
    case "55": return "Titus";
    case "56": return "Philemon";
    case "57": return "Hebrews";
    case "58": return "James";
    case "59": return "1 Peter";
    case "60": return "2 Peter";
    case "61": return "1 John";
    case "62": return "2 John";
    case "63": return "3 John";
    case "64": return "Jude";
    case "65": return "Revelation";
    default: return "Not in Bible";
  }
}

export function getLeaderName(id) {
  return window.leaderNameStash[id];
}

export function getMinistryName(id, context) {
  return new Promise(function(resolve, reject) {
    console.log("Getting ministry with ID: " + id);
    if (window.ministryNameStash.hasOwnProperty(id)) {
      resolve(window.ministryNameStash[id]);
    }
    else {
      window.base.fetch('ministries/' + id, {
        context: context,
        asArray: false,
      }).then(data => {
        //console.log(data);
        window.ministryNameStash[id] = data.name;
        resolve(data.name);
      }).catch(err => {
        Raven.captureException(new Error(JSON.stringify(err)));
        reject(err);
      });
    }
  });
}

var refTrack = [];

export function clearBindings() {
  refTrack.forEach(item => window.base.removeBinding(item));
  refTrack = [];
}

export function listenTo(name, context, callback, query, filter, asArray=true) {
  console.log("Trying to listen to: " + name);
  refTrack.push(window.base.listenTo(name, {
    context: context,
    asArray: asArray,
    queries: query,
    then: rawData => {
      console.log("raw data: ")
      console.log(clone(rawData));

      var data = rawData;
      if (asArray === true) {
        let filterFunc = filter || function() { return true; }
        data = rawData.filter(filterFunc);

        data.sort(window.sortForType(name));
      } else {
        let filterFunc = filter || function() { return true; }

        Object.keys(rawData).forEach(key => {
          if (!filterFunc(rawData[key])) {
            delete data[key];
          }
        })
      }

      callback(data);
    },
    onFailure: err => {
      Raven.captureException(new Error(JSON.stringify(err)));
      window.show('error', "Error Fetching Data", "Could not connect to the server at this time, please try again later.");
      console.error("Error listening to data: ")
      console.error(err);
    }
  }))
}

export function get(name, context, query, filter, asArray=true) {
  return new Promise(function(resolve, reject) {
    console.log("Getting: " + name);
    window.base.fetch(name, {
      context: context,
      asArray: asArray,
      queries: query
    }).then(rawData => {
      console.log("raw data: ")
      console.log(clone(rawData));

      var data = rawData;
      if (asArray === true) {
        let filterFunc = filter || function() { return true; }
        data = rawData.filter(filterFunc);

        data.sort(window.sortForType(name));
      } else {
        let filterFunc = filter || function() { return true; }

        Object.keys(rawData).forEach(key => {
          if (!filterFunc(rawData[key])) {
            delete data[key];
          }
        })
      }

      resolve(data);

    }).catch(err => {
      Raven.captureException(new Error(JSON.stringify(err)));
      window.show('error', "Error Fetching Data", "Could not connect to the server at this time, please try again later.");
      console.log("Error retrieving data: ")
      console.log(err);
      reject(err);
    });
  });
}

export function push(name, context, obj) {
  let object = clone(obj);
  deleteAdded(object);
  return new Promise(function(resolve, reject) {
    if (name.indexOf('undefined') !== -1) {
      console.log("Trying to update undefined object");
      reject();
    }
    console.log("Pushing object: ");
    console.log(object);
    window.base.push(name, {data: object}).then(newData => {
      console.log("new key: ");
      console.log(newData.key);
      if (typeof obj === 'object') {
        object.key = newData.key;
        console.log(object);
        resolve(object);
      } else {
        resolve(newData.key);
      }
    }).catch(err => {
      Raven.captureException(new Error(JSON.stringify(err)));
      window.show('error', "Error Saving Data", "Could not connect to the server at this time, please try again later.");
      console.error("Error pushing data: ")
      console.error(err);
      reject(err);
    });
  });
}

export function trimLocation(location) {
  return location.replace(", FL, United States", "");
}

export function update(name, context, obj) {
  let object = clone(obj);
  deleteAdded(object);
  return new Promise(function(resolve, reject) {
    if (name.indexOf('undefined') !== -1) {
      console.log("Trying to update undefined object");
      reject();
    } else {
      console.log("Updating object at key (" + name + "): ");
      console.log(object);
      window.base.update(name, {data: object}).then(() => {
        console.log("Update successful");
        resolve();
      }).catch((err) => {
        Raven.captureException(new Error(JSON.stringify(err)));
        window.show('error', "Error Saving Data", "Could not connect to the server at this time, please try again later.");
        console.error("Error updating data: ")
        console.error(err);
        reject(err);
      });
    }
  });
}

export function post(name, context, obj) {
  let object = clone(obj);
  deleteAdded(object);
  return new Promise(function(resolve, reject) {
    if (name.indexOf('undefined') !== -1) {
      console.log("Trying to post undefined object");
      reject();
    } else {
      console.log("Posting object to path: " + name);
      console.log(object);
      window.base.post(name, {data: object}).then(() => {
        console.log("Post successful");
        resolve();
      }).catch((err) => {
        Raven.captureException(new Error(JSON.stringify(err)));
        window.show('error', "Error Saving Data", "Could not connect to the server at this time, please try again later.");
        console.warn("Error posting data: ")
        console.warn(err);
        reject(err);
      });
    }
  });
}

export function remove(name) {
  return new Promise(function(resolve, reject) {
    window.base.remove(name, function(err) {
      if (err) {
        reject();
        Raven.captureException(new Error(JSON.stringify(err)));
        console.log(err);
        window.show('error', "Error Saving Data", "Could not connect to the server at this time, please try again later.");
      }
      else {
        resolve();
      }
    });
  });
}


function deleteAdded(object) {
  if (object.roomName) {
    delete object.roomName;
  }
  if (object.leaderName) {
    delete object.leaderName;
  }
  if (object.approver1Name) {
    delete object.approver1Name;
  }
  if (object.approver2Name) {
    delete object.approver2Name;
  }
  if (object.approver3Name) {
    delete object.approver3Name;
  }
}

export function equalTime(date1, date2) {
  return moment.unix(date1).format("h:mm A") === moment.unix(date2).format("h:mm A")
}

function weekOfMonth(date, day) {
  let testDate = getNextDayOfWeek(day, date);
  let week = 0;
  while (date.month() === testDate.month()) {
    testDate.subtract(1, 'weeks');
    week++;
  }
  return week;
}

function getNextDayOfWeek(day, fromDate = moment()) {
  let date = moment(fromDate).day(parseInt(day));
  if (date.isBefore(fromDate.startOf('day'))) {
    date.add(1, 'weeks');
  }
  return date;
}

export function getNameForType(type) {
  if (!type) return "Event";
  switch (type) {
    case "bible": return "Bible Study";
    case "outreach": return "Outreach";
    case "fellowship": return "Fellowship";
    case "prayer": return "Prayer Meeting";
    case "sunday": return "Sunday Service";
    default: return "Event";
  }
}

// event is either a bible study or outreach event
export function nextMeeting(base, count = 0, fromDate = moment()) {
  let startTime = moment.unix(base.date);
  let date = null;
  if (base.interval === 'weekly') {
    date = getNextDayOfWeek(base.day, fromDate);
  } else if (base.interval === 'biWeekly') {
    let week = weekOfMonth(getNextDayOfWeek(base.day, fromDate), base.day);
    if (((week === 1 || week === 3) && base.weeklyInterval === '1/3') || ((week === 2 || week === 4) && base.weeklyInterval === '2/4'))
      date = getNextDayOfWeek(base.day, fromDate);
    else
      date = getNextDayOfWeek(base.day, fromDate).add(1, 'weeks');
  } else {
    if (base.monthlyType === "onDay") {
      date = moment(fromDate).date(base.dayOfMonth);
      if (date.isBefore(fromDate.startOf('day')))
        date.add(1, 'months');
    } else {
      date = getNextDayOfWeek(base.day, fromDate);
      let week = weekOfMonth(date, base.day);
      if (base.weekOfMonth - week >= 0)
        date.add(base.weekOfMonth - week, 'weeks');
      else {
        while (date.month() === moment(date).add(1, 'weeks').month())
          date.add(1, 'weeks');
        date.add(base.weekOfMonth, 'weeks');
      }
    }
  }
  let array = [date.second(startTime.second()).minute(startTime.minute()).hour(startTime.hour())];
  if (count === 0)
    return array;
  else
    return array.concat(nextMeeting(base, count - 1, moment(array[0]).add(1, 'days')))
}

export function getEventForWeekly(weekly, asArray = false) {
  let nexts = nextMeeting(weekly.base, asArray ? 3 : 0);
  let outArray = nexts.map(next => {
    let nextKey = next.unix().toString();
    return {
      key: weekly.key,
      title: weekly.title,
      description: weekly.base.description,
      atCCO: weekly[nextKey] ? (weekly[nextKey].atCCO || weekly.base.atCCO) : weekly.base.atCCO,
      location: weekly[nextKey] ? (weekly[nextKey].location || weekly.base.location) : weekly.base.location,
      locationChanged: weekly[nextKey] && weekly[nextKey].location !== undefined,
      teacher: weekly.type === 'bible' ? (weekly[nextKey] ? (weekly[nextKey].guestSpeaker || weekly.base.teacher) : weekly.base.teacher) : null,
      teacherChanged: weekly[nextKey] && weekly[nextKey].guestSpeaker !== undefined,
      date: moment(next).unix(),
      endDate: moment(next).add(weekly.base.endDate - weekly.base.date, 'seconds').unix(),
      ministryID: weekly.ministryID,
      interval: weekly.base.interval,
      type: weekly.type,
      canceled: weekly[nextKey] ? weekly[nextKey].canceled : null,
      originator: weekly.ministryLeader
    }
  });
  if (!asArray)
    return outArray[0];
  else
    return outArray;
}

export function getDayFromNumber(num) {
  let number = parseInt(num);
  if (number === 0) return "Sunday";
  if (number === 1) return "Monday";
  if (number === 2) return "Tuesday";
  if (number === 3) return "Wednesday";
  if (number === 4) return "Thursday";
  if (number === 5) return "Friday";
  if (number === 6) return "Saturday";
}

export function needsApproval(event) {
  let returnArray = [];
  if (event.atCCO)
    returnArray.push("approval1")
  if (event.ministryID === "cco" || event.wholeChurch)
    returnArray.push("approval2")
  if (event.techSetup)
    returnArray.push("approval3")
  if ((event.atCCO || event.techSetup) && !event.approval4)
    returnArray.push("approval4")

  if (returnArray.length > 0)
    return returnArray;
  else
    return null;
}

export function getRoomNames(objects) {
  var newObjects = [];
  objects.forEach(object => {
    object.roomName = getRoomName(object);
    newObjects.push(object);
  });
  return newObjects;
}

export function getRoomName(object) {
  switch (object.location) {
    case "c": return "Entire Church";
    case "f": return "Fellowship Hall";
    case "s": return "Sancturary";
    case "h": return "High School Room (Room 20)";
    case "m": return "Junior High Room (Room 21)";
    case "k": return "Game Room (Room 4)";
    case "l": return "Conference Room";
    default: return "The Church Somewhere";
  }
}

export function isUpcoming(date) {
  return moment.unix(date).isAfter(moment().startOf('day'))
}

export function isPast(date) {
  return moment.unix(date).isBefore(moment().startOf('day'))
}

export function parseVerse(verse) {

  let parsedVerse = {};

  if (verse.book === null) return null;

  if(!isNumeric(verse.book)) {
    parsedVerse.book = 0;
  } else {
    parsedVerse.book = verse.book;
  }

  if (!isNumeric(verse.startChapter)) {
    console.log("bad startchapter");
    return null;
  }
  parsedVerse.startChapter = parseInt(verse.startChapter, 10);

  if (isNumeric(verse.endChapter)) {
    if (verse.endChapter != verse.startChapter)
      parsedVerse.endChapter = parseInt(verse.endChapter, 10);
  } else if (verse.endChapter && verse.endChapter !== "") {
    console.log("bad endchapter: " + verse.endChapter);
    return null;
  }

  if (isNumeric(verse.startVerse)) {
    parsedVerse.startVerse = parseInt(verse.startVerse, 10);
  } else if (verse.startVerse && verse.startVerse !== "") {
    console.log("bad startverse");
    return null;
  }

  if (isNumeric(verse.endVerse)) {
    if (!verse.startVerse) {
      parsedVerse.startVerse = 1;
    }
    parsedVerse.endVerse = parseInt(verse.endVerse, 10);
  } else if (verse.endVerse && verse.endVerse !== "") {
    console.log("bad endverse");
    return null;
  }


  // Check ordering
  if (parsedVerse.endChapter && parsedVerse.endChapter < parsedVerse.startChapter) return null;
  if (parsedVerse.endVerse && parsedVerse.startVerse && (!parsedVerse.endChapter || parsedVerse.endChapter === parsedVerse.startChapter) && parsedVerse.endVerse < parsedVerse.startVerse) return null;

  return parsedVerse;
}

export function getPage(loc) {
  if (loc.split("/").length < 2) return null;
  return loc.split("/")[1];
}

export function getTab(loc) {
  if (loc.split("/").length < 3) return "n/a";
  return loc.split("/")[2];
}

export function locationIsMinistry() {
  return (location.pathname.split("/")[1].indexOf("-") === 0 || location.pathname.split("/")[1] === "cco");
}

export function locationValid(loc) {
  var validLocations = ["sermons", "approval1", "approval2", "approval3", "week", "calendar", "events", "announcements", "settings", "bible", "outreach", "service", "encouragement", "profile"];
  return validLocations.indexOf(loc.split("/")[loc.split("/").length - 1]) !== -1;
}



/** WEBPACK FOOTER **
 ** ./src/util/Utility.js
 **/